if (!customElements.get('text-collapsible')) {
  class TextCollapsible extends HTMLElement {
    constructor() {
      super();

      this.targetText = this.querySelector('[data-target-text]');
      this.triggerBtn = this.querySelector('[data-trigger-button]');

      if (this.targetText && this.triggerBtn) {
        this.toggleBtn();
      }
    }

    toggleBtn() {
      // Show and hide the rest of the text
      this.triggerBtn.addEventListener('click', () => {
        this.targetText.classList.toggle('line-clamp-[--line-clamp-num]');

        // Change button content in tailwind classes
        this.triggerBtn.classList.toggle('text-is-open');
      });
    }
  }
  window.TextCollapsible = TextCollapsible;
  customElements.define('text-collapsible', TextCollapsible);
}
